
@if (companyId != null) {
  <div class="row" style="padding-bottom: 15px">
    <div class="col-sm-8" style="display: flex; flex-wrap: wrap; align-items: flex-start; gap: 8px;">
      <button mat-raised-button class="filter-btn" (click)="reset()" matTooltip="Reset Filters" matTooltipPosition="above" aria-label="Button that Resets All the Filters." matTooltipClass="resetFiltersClass">
        <mat-icon>restart_alt</mat-icon>
      </button>
      <app-template-select-multi-btn
        class="filter-btn"
        [(selected)]="templateIds"
        [(allSelected)]="allTemplatesSelected"
        (onClosed)="getHarvests()">
      </app-template-select-multi-btn>
      <app-harvest-select-multi-btn
        class="filter-btn"
        [showUpcomingHarvests]="false"
        [appStorageNeeded]="false"
        [(selected)]="harvestIds"
        (onClosed)="getHarvests()"
        (loaded)="getHarvests()">
      </app-harvest-select-multi-btn>
      <app-zone-select-multi-btn
        class="filter-btn"
        [(selected)]="zoneIds"
        (onClosed)="getHarvests()"
        >
      </app-zone-select-multi-btn>
      <mat-slide-toggle class="gridbtn" [(ngModel)]="appStorage.showFinishedHarvests" (change)="getHarvests()">Include Finished Harvests</mat-slide-toggle>
    </div>
    <div class="col-sm-4">
      <div style="float: right">
        <app-dutchie-btn (addedHarvests)="addedHarvests($event)"></app-dutchie-btn>
        @if (canSeeHarvestAdd) {
          <button mat-raised-button color="primary" class="gridbtn" (click)="addHarvest()" title="Add Harvest">
            <mat-icon>add</mat-icon> Add Harvest
          </button>
        }
        @if (canSeeHarvestGroupDelete) {
          <button mat-raised-button class="gridbtn" [matMenuTriggerFor]="menu">
            <mat-icon>more_vert</mat-icon>
          </button>
        }
        <mat-menu #menu="matMenu">
          <app-harvest-shift-btn [dropDownMenu]="true"></app-harvest-shift-btn>
          @if (canSeeHarvestGroupDelete) {
            <button mat-menu-item (click)="harvestGroupDelete()" title="Delete Harvests">
              <mat-icon aria-hidden="false" aria-label="Delete Harvests">delete</mat-icon>
              <span>Delete Harvests</span>
            </button>
          }
        </mat-menu>
      </div>
    </div>
  </div>
}
<div class="row" style="width: 100%; padding-bottom: 15px; margin: 0px">
  <div class="col-sm-12" style="padding: 0;">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>Timeline</mat-panel-title>
        </mat-expansion-panel-header>
        <app-timeline [dataList]="timelineData" [dateFormat]="timelineDateFormat" [colors]="timelineColors"></app-timeline>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
<div class="row pc-pt-wrapper">
  <div class="col-12" style="padding: 0;">
    <p-table
      [value]="tableRows"
      dataKey="harvestId"
      [loading]="tableLoading"
      [scrollable]="true"
      scrollHeight="calc(100vh - 360px)"
      [paginator]="tableRows.length > 15"
      [rows]="15"
      [rowsPerPageOptions]="[15, 30, 50]"
      [rowHover]="true"
      sortField="startDateMs"
      [sortOrder]="harvestListSortDirection === 'desc' ? -1 : 1"
      (onSort)="onTableSort($event)"
      styleClass="p-datatable-sm pc-harvest-table"
      currentPageReportTemplate="{first}–{last} of {totalRecords}"
      [showCurrentPageReport]="true">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">Name <p-sortIcon field="name" /></th>
          @if (showDutchieColumn) {
            <th pSortableColumn="leaflogixName">Dutchie Name <p-sortIcon field="leaflogixName" /></th>
          }
          <th pSortableColumn="startDateMs">Clone Date <p-sortIcon field="startDateMs" /></th>
          <th class="pc-timeline-h" style="min-width: 200px;">Phase timeline</th>
          <th pSortableColumn="harvestDateMs">Harvest Date <p-sortIcon field="harvestDateMs" /></th>
          <th pSortableColumn="endDateMs">End Date <p-sortIcon field="endDateMs" /></th>
          <th pSortableColumn="percentComplete" style="min-width: 9rem;">Completed <p-sortIcon field="percentComplete" /></th>
          <th pSortableColumn="strains">Strains <p-sortIcon field="strains" /></th>
          <th pSortableColumn="plantCount">Plant Count <p-sortIcon field="plantCount" /></th>
          <th pSortableColumn="zone">Zone <p-sortIcon field="zone" /></th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-h>
        <tr class="pc-row" (click)="openHarvest(h)">
          <td>
            <span class="pc-name">
              <span class="pc-dot" [style.background]="h.color || '#9aa39d'"></span>
              <span class="pc-name-text">{{ h.name }}</span>
            </span>
          </td>
          @if (showDutchieColumn) {
            <td>{{ h.leaflogixName }}</td>
          }
          <td>{{ formatDate(h.startDate) }}</td>
          <td class="pc-timeline-cell">
            <div class="pc-timeline" [pRowToggler]="h" (click)="$event.stopPropagation()"
                 title="Click to show phase dates">
              @if (h.timeline?.length) {
                @for (seg of h.timeline; track seg.name) {
                  <div class="pc-seg" [style.flex]="seg.weight" [style.background]="seg.color"
                       [attr.title]="seg.name + ' · ' + formatDate(seg.start)"></div>
                }
              } @else {
                <span class="pc-timeline-empty">—</span>
              }
            </div>
          </td>
          <td>{{ formatDate(h.harvestDate) }}</td>
          <td>{{ formatDate(h.endDate) }}</td>
          <td>
            <div class="pc-progress" [attr.title]="(h.percentComplete | number:'1.0-0') + '%'">
              <div class="pc-progress-fill" [style.width.%]="h.percentComplete || 0"></div>
              <span class="pc-progress-label">{{ h.percentComplete | number:'1.0-0' }}%</span>
            </div>
          </td>
          <td>{{ h.strains }}</td>
          <td>{{ h.plantCount }}</td>
          <td>{{ h.zone }}</td>
        </tr>
      </ng-template>

      <ng-template pTemplate="expandedrow" let-h>
        <tr class="pc-expanded-row">
          <td [attr.colspan]="totalColumnCount">
            @if (h.timeline?.length) {
              <div class="pc-stepper">
                @for (seg of h.timeline; track seg.name) {
                  <div class="pc-step">
                    <span class="pc-step-dot" [style.background]="seg.color"></span>
                    <span class="pc-step-name">{{ seg.name }}</span>
                    <span class="pc-step-date">{{ formatDate(seg.start) }}</span>
                  </div>
                }
              </div>
            } @else {
              <div class="pc-stepper-empty">No phase data for this harvest.</div>
            }
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="footer">
        @if (tableRows.length > 0) {
          <tr class="pc-footer">
            <td [attr.colspan]="colsBeforePlantCount" class="pc-footer-label">
              {{ tableRows.length }} harvest{{ tableRows.length === 1 ? '' : 's' }}
            </td>
            <td class="pc-footer-total">{{ totalPlantCount | number }}</td>
            <td></td>
          </tr>
        }
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="totalColumnCount" class="pc-empty">{{ tableLoading ? 'Loading harvests…' : 'No harvests to show.' }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<div class="row" style="padding: 15px 0px">
  <div class="col-sm-12 right">
    <button class="gridbtn" mat-raised-button (click)="exportAsCSV()">Export as CSV</button>
  </div>
</div>